/** Aktionsprotokoll (admin): letzte Zeilen aus actions.log. */

import { useSignal, useSignalEffect } from "@preact/signals";
import { api } from "../store";
import { PageHead, Panel } from "../components";
import { PanelGrid, type PanelItem } from "../grid/PanelGrid";
import type { ApiResponse } from "../api";
import { t } from "../i18n";

export function Log() {
  const lines = useSignal<string[]>([]);
  const loading = useSignal(false);
  const edit = useSignal(false);

  async function load() {
    loading.value = true;
    try {
      const r = await api.call<ApiResponse & { lines: string[] }>("log");
      if (r.ok) lines.value = r.lines;
    } finally {
      loading.value = false;
    }
  }
  useSignalEffect(() => { void load(); });

  const items: PanelItem[] = [{
    id: "log", title: t("nav.log"), defaultSpan: 12,
    render: () => (
      <Panel>
        <div class="mono" style="white-space:pre-wrap;font-size:13px;line-height:1.7;max-height:64vh;overflow:auto">
          {lines.value.length === 0 ? (
            <div class="empty">{t("audit.empty")}</div>
          ) : (
            lines.value.slice().reverse().map((l, i) => <div key={i} class="muted">{l}</div>)
          )}
        </div>
      </Panel>
    ),
  }];

  return (
    <div class="view-enter">
      <PageHead title={t("nav.log")} sub={t("log.sub")}>
        <button class={`btn sm ${edit.value ? "primary" : ""}`} onClick={() => (edit.value = !edit.value)}>{edit.value ? t("dashboard.editDone") : t("dashboard.edit")}</button>
        <button class="btn sm" onClick={() => void load()} disabled={loading.value}>↻ {t("common.refresh")}</button>
      </PageHead>
      <PanelGrid view="log" items={items} edit={edit} />
    </div>
  );
}
